import { render, staticRenderFns } from "./PrivacityNotice.vue?vue&type=template&id=72f90aeb&scoped=true&"
import script from "./PrivacityNotice.vue?vue&type=script&lang=ts&"
export * from "./PrivacityNotice.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacityNotice.vue?vue&type=style&index=0&id=72f90aeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f90aeb",
  null
  
)

export default component.exports